import "./src/styles/global.css"

import { initFirebase } from './src/firebase/core';

export const onClientEntry = () => 
{
  initFirebase();
};